import MonthlyFinancialPosition from '../tool/MonthlyFinancialPosition';
import InterestDisclosure from '../tool/InterestDisclosure';
import ProductSuitability from '../tool/ProductSuitability';
import RiskInsuranceComplianceVerifications from './RiskInsuranceComplianceVerifications';
import type { IRiskInsuranceCompliance } from './RiskInsuranceCompliance.interface';

export default class RiskInsuranceCompliance implements IRiskInsuranceCompliance {
  monthlyFinancialPosition: MonthlyFinancialPosition;
  verifications: RiskInsuranceComplianceVerifications;
  interestDisclosure: InterestDisclosure;
  productSuitability: ProductSuitability;

  static build = (data: IRiskInsuranceCompliance) => new RiskInsuranceCompliance(data);
  static blank = () => new RiskInsuranceCompliance();

  /**
   * Constructor
   * @param {IRiskInsuranceCompliance} data
   */
  constructor(data?: IRiskInsuranceCompliance) {
    this.monthlyFinancialPosition = new MonthlyFinancialPosition(
      data?.monthlyFinancialPosition
    );
    this.verifications = new RiskInsuranceComplianceVerifications(data?.verifications);
    this.interestDisclosure = new InterestDisclosure(data?.interestDisclosure);
    this.productSuitability = new ProductSuitability(data?.productSuitability);
  }
}
